import { loadingSpinnerActions } from "../../actions/loadingSpinnerActions";
var RitualsReduxProps = {
    mapDispatchToProps: function (dispatch) {
        return {
            onShowSpinner: function () { return dispatch({ type: loadingSpinnerActions.SHOW_SPINNER_MODAL }); },
            onHideSpinner: function () { return dispatch({ type: loadingSpinnerActions.HIDE_SPINNER_MODAL }); },
        };
    }
};
export default RitualsReduxProps;



//////////////////
// WEBPACK FOOTER
// ./src/views/Rituals/RitualsReduxProps.ts
// module id = 445
// module chunks = 0